<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Exam Marksheet" value="exam" color="#0f2027"></v-radio>
                <v-radio label="Annual Marksheet" value="marksheet" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                        @change="getassschemedetails();getStud()"
                        @click="show = false"
                    />
                </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                 
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="radios=='exam'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="asd"
                        :items="assessment_detail_list"
                        item-text="assessmenttype"
                        item-value="id"
                        return-object
                        label="Assessment Type"
                        persistent-hint
                        hint="Please select Assessment Type"
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        v-model="registration_no"
                        rounded
                        color="#0F2027"
                        :items="stud_list"
                        label="Select Student"
                        item-text="name"
                        return-object
                        outlined
                        dense
                        @click="show = false"
                        persistent-hint
                        hint="Please select Student"
                    />
                </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && asd && registration_no && radios=='exam' && this.sem">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport()">Fetch / Generate</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-else>
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport3()">Fetch / Generate </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                default_value: [],
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                fetch_loader: false,
                show: false,
                stud_list: [],
                registration_no:null,
                awspath: "",
                assessment_detail_list:[],
                asd:null,
                radios:'exam',
                fecth_gen_btn_loader:false,
                sem:null,
                semester_list: [],
            };
        },
        watch: {
            sem() {
                this.registration_no = null;
            },
        },
        methods: {
            
            getassschemedetails(){
                const data={
                    ay:this.sel_ay_data.ay_id
                }
                axios
                    .post("/WWSExamination/getassschemedetailsconfig",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
          
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            getreport3(){
                localStorage.setItem("setsem", this.sem);
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                let routeData = this.$router.resolve({
                    name: "sgs-xi-annual-marksheet",
                });
                window.open(routeData.href, "_blank");
            },
            async getreport() {
                localStorage.setItem("setsem", this.sem);
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setasd", this.asd.id);
                localStorage.setItem("setreg_no",this.registration_no.registration_number
                );
              let routeData = this.$router.resolve({
                name: "sgs-xi-marksheet",
            });
            window.open(routeData.href, "_blank");
            },
          
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                (this.stud_list = []), (this.registration_no = null);
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/AccountingAndFees/getChildList_for_marksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if ((res.data.status = "SUCCESS")) {
                                this.stud_list = res.data.learners;
                            } else {
                                alert(res.data.status_reason);
                            }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list=res.data.semester_list;
                       
                       // this.getassschemedetails();
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
   
</style>